import { Skeleton } from "../../skeleton";
import { useBoundField, type FieldProps } from "../field-state";

/**
 * An empty numeric field is NaN. Validators must reject it before persistence.
 *
 * 外壳用 s-text-field：s-number-field 自带的加减档按钮在 Polaris 里关不掉
 * （spec 里的 controls 这个版本没实现，observedAttributes 里都没有），设计稿上也没有。
 * 代价是浏览器不再替我们挡非数字输入，所以下面自己过滤：数字 + 一个小数点 + 最多两位小数。
 */
export function NumberField({
  loading = false,
  skeletonClassName = "h-8",
  ...props
}: FieldProps<"s-text-field"> & { loading?: boolean; skeletonClassName?: string }) {
  const { field, error, dismissError, handleBlur } = useBoundField<number>();
  if (loading) return <Skeleton className={skeletonClassName} />;
  return (
    <s-text-field
      {...props}
      name={field.name}
      value={Number.isFinite(field.state.value) ? String(field.state.value) : ""}
      error={error}
      onFocus={dismissError}
      onInput={(event) => {
        dismissError();
        const element = event.currentTarget;
        const next = element.value.replace(/[^\d.]/g, "");
        const value = /^\d*\.?\d{0,2}/.exec(next)?.[0] ?? "";
        if (value !== element.value) element.value = value;
        field.handleChange(value === "" ? NaN : Number(value));
      }}
      onBlur={handleBlur}
    />
  );
}
